var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'tabela-suspensa-container',
    _vm.mensagemSuspensa.tipo == 'nao-vigente'
      ? 'tabela-suspensa-container-vermelho'
      : _vm.mensagemSuspensa.tipo == 'alterado'
      ? 'tabela-suspensa-container-amarelo'
      : ''
  ]},[_c('div',{class:[
      'tabela-suspensa-mensagem',
      _vm.mensagemSuspensa.tipo == 'nao-vigente'
        ? 'tabela-suspensa-mensagem-vermelho'
        : _vm.mensagemSuspensa.tipo == 'alterado'
        ? 'tabela-suspensa-mensagem-amarelo'
        : ''
    ]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.mensagemSuspensa.titulo)}}),_c('div',{staticClass:"tabela-suspensa-fechar",on:{"click":_vm.fechaTabelaSuspensa}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_c('TabelaPadrao',{attrs:{"clickLinha":_vm.click,"semTitulo":"","templateColumns":"150px 5fr","conteudoPaginado":_vm.conteudo,"conteudoTotal":_vm.conteudo,"estruturaTabela":_vm.estruturaTabela,"alertaVermelho":"Identificamos que o produto não se encontra mais vigente ou foi alterado, entretanto localizamos uma ou mais NCMs correlacionadas vigentes que podem substituir. <br>Clique aqui para selecionar uma nova NCM.","caminhoAlertaVermelho":"vigente","mensagemRepetido":"Essa NCM já consta na lista de NCMs selecionadas."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }